import React, { useEffect } from 'react'
import GSPTable, { InputFilter } from 'azm-components'
// import GSPTable, { InputFilter } from '../../../../../components/GSFTable'
import { CCol, CFormInput, CFormSelect, CFormText, CRow } from '@coreui/react'
import CustomValuesHook from '../../../../../../Hooks/customValuesHook'
import { useSelector } from 'react-redux'
import ContactTableColumns from '../columns'
import { useDispatch } from 'react-redux'
import { ContactListToBlockRequestAction, getAllContactsRequestAction, getContactRequestAction, resetContactPropsAction, updateContactRequestAction } from '../../../../../../service/actions/contactActions'
import { ArrowBackSvg, CallSVG, CircleArrowRightSVG, CloseSVG, LeftArrowSVG, PhoneSVG, PhoneSvg, SearchSVG } from '../../../../../../components/IconSvg'
import StackTools from '../stackTools'
import { checkForNumericEnFaString, enToPersianChar, numberPreparationInContact, persianToEnglishChar } from '../../../../../../components/helper'
import ContactCategories from '../../contactCategories'
import DSAppPhonebook from './DSAppPhonebook'
import '../../../style.scss'
import CallModal from './callModal'
import "./dsapp.scss"

const DSApplicationContact = () => {
    const [states, setStates] = CustomValuesHook({ columns: [], selectionList: [], getContactParams: {}, searchType: "all" })
    const getDataPending = useSelector(state => state.contactReducer.getContactPending)
    const phonebooks = useSelector(state => state.contactReducer.unpagedPhonebook)
    const contactCategories = useSelector(state => state.contactReducer.contactCategories)
    const updateContactPending = useSelector(state => state.contactReducer.updateContactPending)
    const updateContactSuccess = useSelector(state => state.contactReducer.updateContactSuccess)
    const contacts = useSelector(state => state.contactReducer.contacts)
    const blockSuccess = useSelector((state) => state.contactReducer.contactListToBlockSuccess)
    const deleteSuccess = useSelector((state) => state.contactReducer.removeFromPhoneBookContactSuccess)
    const moveSuccess = useSelector((state) => state.contactReducer.moveByContactSuccess)
    const copySuccess = useSelector((state) => state.contactReducer.copyByContactSuccess)
    const selectedContactCategory = useSelector((state) => state.contactReducer.selectedContactCategory)
    const successAdd = useSelector((state) => state.contactReducer.addContactSuccess)

    useEffect(() => {


        const goftinoContext = document.getElementById("box-widget-icon")
        if (goftinoContext) {
            goftinoContext.style.display = "none"
        }

        return (() => {
            if (goftinoContext) {
                goftinoContext.style.display = "block"
            }
        })
    }, [])

    const dispatch = useDispatch()

    const handleUpdateContact = (contact) => {

        dispatch(updateContactRequestAction({
            ...contact,
            defaultNumber: '+' + contact.defaultNumber,
            number2: numberPreparationInContact(contact.number2),
            number3: numberPreparationInContact(contact.number3),
            number4: numberPreparationInContact(contact.number4),
        }))
    }
    const handleBlockContacts = (contactId, type) => {

        dispatch(ContactListToBlockRequestAction({
            isInBlackList: type,
            contacts: [contactId]
        }))


    }

    const handleGetContact = (args, type) => {


        args.sortText = "Contact.Name ASC"
        if (!type) {
            args.whereConditionText = states.getContactParams.whereConditionText

        }
        dispatch(getContactRequestAction({ ...args, disablePaging: true }))

        setStates({ getContactParams: { ...states.getContactParams, ...args } })
    }

    useEffect(() => {
        if (updateContactSuccess || deleteSuccess || blockSuccess || copySuccess || moveSuccess || successAdd) {
            setStates({ selectionList: [] })
            handleGetContact(states.getContactParams)
            dispatch(getAllContactsRequestAction({
                pageNumber: 1,
                pageSize: 1000,
                sortText: "",
                whereConditionText: "",
                disablePaging: false
            }))
            dispatch(resetContactPropsAction())

        }
    }, [updateContactSuccess, deleteSuccess, blockSuccess, copySuccess, moveSuccess, successAdd])

    useEffect(() => {

        handleCreateSearchText()

    }, [states.searchText, states.searchType, selectedContactCategory])


    useEffect(() => {
        setStates({ contacts: contacts })
    }, [contacts])

    const handleCreateSearchText = () => {
        let searchQueryText = ""

        switch (states.searchType) {
            case "name":
                if (states.searchText && states.searchText !== "") {
                    searchQueryText = `(Contact.Name.ToLower().Contains("${states.searchText}") || Contact.FamilyName.ToLower().Contains("${states.searchText}"))`
                }

                break;
            case "number":
                if (states.searchText && states.searchText !== "") {
                    searchQueryText = `Contact.DefaultNumber.ToLower().Contains("${states.searchText}") ||  Contact.Number2.ToLower().Contains("${states.searchText}") || Contact.Number3.ToLower().Contains("${states.searchText}") || Contact.Number4.ToLower().Contains("${states.searchText}")`
                }

                break;
            case "phonebook":
                if (states.searchText && states.searchText !== "") {
                    for (let i = 0; i < phonebooks.data.length; i++) {
                        if (phonebooks.data[i].name.indexOf(states.searchText) > -1) {
                            searchQueryText += `${searchQueryText !== "" ? '|| ' : ''} PhoneBookId =="${phonebooks.data[i].id}"`
                        }
                    }
                }

                break;
            case "all":
            case "contactCategory":
                if (states.searchText && states.searchText !== "") {

                    searchQueryText = `(Contact.Name.ToLower().Contains("${states.searchText}") || Contact.FamilyName.ToLower().Contains("${states.searchText}")|| PhoneBook.Name.Contains("${states.searchText
                        }") || Contact.DefaultNumber.ToLower().Contains("${persianToEnglishChar(states.searchText)}") || Contact.Number2.ToLower().Contains("${persianToEnglishChar(states.searchText)}") || Contact.Number3.ToLower().Contains("${persianToEnglishChar(states.searchText)
                        }") || Contact.Number4.ToLower().Contains("${persianToEnglishChar(states.searchText)}"))`
                    // if (checkForNumericEnFaString(states.searchText)) {
                    //     searchQueryText += ` || Contact.DefaultNumber.ToLower().Contains("${persianToEnglishChar(states.searchText)}") || Contact.Number2.ToLower().Contains("${persianToEnglishChar(states.searchText)}") || Contact.Number3.ToLower().Contains("${persianToEnglishChar(states.searchText)
                    //         }") || Contact.Number4.ToLower().Contains("${persianToEnglishChar(states.searchText)}")`

                    // }

                }

                if (selectedContactCategory) {
                    searchQueryText += `${searchQueryText === "" ? '' : '&&'} Contact.PhonebookContactCategorys.Any(c=>c.ContactCategoryId="${selectedContactCategory.id}")`
                }
                break;
            default:
                break;

        }
        let params = { ...states.getContactParams }
        if (params.disablePaging !== undefined) {
            params.pageNumber = 1;
            params.whereConditionText = searchQueryText
            setStates({ getContactParams: { whereConditionText: searchQueryText } })
            handleGetContact(params, true)
        }




    }

    const customCardView = ({
        dataList,
        dataListToDisplay,
        columns,
        setDataListFromItem,
        customProps
    }) => {

        const handleItemClick = (idx) => {

            let temp = [...dataList]
            temp.forEach((_item, _idx) => {
                if (_idx !== idx) {
                    _item.isOpen = false
                }
            })
            temp[idx].isOpen = temp[idx].isOpen === true ? false : true
            setDataListFromItem([...temp])
        }
        return (
            <div className='contact-list-custom-card-view' >
                {
                    dataList?.map((item, index) => {


                        return (
                            <div className={`contact-ds-card-view ${item.isOpen ? 'opened' : ''}`} key={index} onClick={() => handleItemClick(index)} >
                                <div className='d-flex justify-content-between' >
                                    <div

                                        className={`info-context`}>
                                        <div className='prf-circle'>{item.name.toUpperCase().charAt(0)}</div>
                                        <div className='name-context' >{item.name} {item.familyName}</div>

                                    </div>
                                    {!item.isOpen && <div className='call-btn-container' >
                                        <span onClick={(e) => {
                                            e.stopPropagation();
                                            setStates({
                                                displayCallModal: true,
                                                toNumberToCall: item.defaultNumber
                                            })
                                        }}>
                                            <PhoneSVG />
                                        </span>

                                    </div>}
                                </div>
                                <div className='d-flex numbers-list' >
                                    <div className='numberItem' onClick={() => setStates({
                                        displayCallModal: true,
                                        toNumberToCall: item.defaultNumber
                                    })} >
                                        <label>{enToPersianChar(item.defaultNumber)}</label>
                                        <span>
                                            <PhoneSvg width={15} height={15} />
                                        </span>
                                    </div>
                                    {item.number2 && <div className='numberItem' onClick={() => setStates({
                                        displayCallModal: true,
                                        toNumberToCall: item.number2
                                    })}  >
                                        <label>{enToPersianChar(item.number2)}</label>
                                        <span>
                                            <PhoneSvg width={15} height={15} />
                                        </span>
                                    </div>}
                                    {item.number3 && <div onClick={() => setStates({
                                        displayCallModal: true,
                                        toNumberToCall: item.number3
                                    })} className='numberItem' >
                                        <label>{enToPersianChar(item.number3)}</label>
                                        <span>
                                            <PhoneSvg width={15} height={15} />
                                        </span>
                                    </div>}
                                    {item.number4 && <div
                                        onClick={() => setStates({
                                            displayCallModal: true,
                                            toNumberToCall: item.number4
                                        })}
                                        className='numberItem' >
                                        <label>{enToPersianChar(item.number4)}</label>
                                        <span>
                                            <PhoneSvg width={15} height={15} />
                                        </span>
                                    </div>}
                                </div>



                            </div>
                        )

                    })
                }
            </div>
        )
    }

    const selectPhoneBook = (selectedPhoneBook, phonebookContacts) => {
        setStates({ selectedPhoneBook, phonebookContacts, phonebookContactsToSearch: phonebookContacts })
    }
    const handleSearchOnPhonebookContacts = (searchText) => {
        const filteredContact = states.phonebookContactsToSearch.filter((item) => {
            return item.name.indexOf(searchText) > -1 ||
                item.familyName.indexOf(searchText) > -1 ||
                item.defaultNumber.indexOf(searchText) > -1 ||
                (item.number2 && item.number2.indexOf(searchText) > -1) ||
                (item.number3 && item.number3.indexOf(searchText) > -1) ||
                (item.number4 && item.number4.indexOf(searchText) > -1);
        });
        setStates({ phonebookContacts: searchText !== "" ? filteredContact : states.phonebookContactsToSearch })

    }

    return (
        <div className='contacts-page ds-app-contact' style={{ paddingTop: '3px' }}>
            {states.callError && <div className='ds-error' >{states.callError}</div>}
            {states.callSuccess && <div className='ds-call-in-progress' onClick={() => setStates({ callSuccess: false })} >
                <div>

                    <div>
                        {`در حال تماس از شماره ${states.from}`}
                    </div>
                    <div>
                        {`به شماره ${states.to}`}...
                    </div>

                </div>
            </div>}

            {states.displayCallModal &&
                <CallModal
                    fromNumber={states.fromNumberToCall | "99999999"}
                    toNumber={states.toNumberToCall}
                    close={() => setStates({ displayCallModal: false, callError: null })}
                    setError={(error) => setStates({ callError: error })}
                    setInCall={(params) => setStates({ ...params, displayCallModal: false, callError: null })}
                />}

            <ContactTableColumns
                setColumns={(columns) => setStates({ columns: [...columns] })}
                setSelectedList={(list) => setStates({ selectedList: list })} />
            {!states.selectedPhoneBook ? <>

                <div className='top-context' >
                    <DSAppPhonebook selectPhoneBook={selectPhoneBook} />

                    <div className='search-tools  mb-2' >
                        <CRow>
                            <CCol lg={3} xs={12}>
                                <div className='search-input-container mx-2 mt-1'>
                                    <CFormInput
                                        value={states.searchText}
                                        onChange={(e) => {

                                            if (states.searchType === "number") {
                                                if (e.target.value !== '') {
                                                    if (checkForNumericEnFaString(e.target.value)) {
                                                        setStates({ searchText: persianToEnglishChar(e.target.value) })
                                                    }
                                                } else {
                                                    setStates({ searchText: '' })

                                                }

                                            } else {
                                                setStates({ searchText: e.target.value })

                                            }



                                        }}
                                        type="text"
                                        className="form-control"
                                        placeholder='search'
                                    />
                                    {states.searchText && <span className='remove-selected-spn'
                                        onClick={(e) => {
                                            setStates({ searchText: '' })

                                        }} >
                                        <CloseSVG fill='red' />
                                    </span>}
                                    <span>
                                        <SearchSVG width={20} height={20} fill='#333' />
                                    </span>
                                </div>

                            </CCol>



                        </CRow>
                    </div>
                </div>
                <div className='scrollable-context' >

                    <GSPTable
                        columns={states.columns}
                        hasSorting={false}
                        dataList={states.contacts}
                        apiCall={handleGetContact}
                        hasFiltering={false}
                        loading={getDataPending}
                        enableScrolling={false}
                        hasPaging={false}
                        pageSize={10}
                        isDynamicColumns={false}
                        customProps={{
                            selectedList: states.selectionList,
                            setInnerSelectedList: setStates,
                            phonebookList: phonebooks?.data,
                            contactCategories: contactCategories?.data,
                            updateContact: handleUpdateContact,
                            updateContactPending: updateContactPending,
                            handleBlock: handleBlockContacts
                        }}
                        customCardView={customCardView}
                        setDataListFromItem={(list) => { setStates({ contacts: { ...states.contacts, data: list } }) }}
                    />
                </div>



                {contacts.data.length === 0 && <div className='no-data' > هیچ اطلاعاتی برای نمایش وجود ندارد </div>}
                <StackTools selectedList={states.selectionList} isGetMargin={contacts?.data?.totalCount > 10} />
            </> : <>
                <div className='top-context' >
                    <DSAppPhonebook selectPhoneBook={selectPhoneBook} />
                    <div className='search-tools  mb-2' >
                        <CRow>
                            <CCol lg={3} xs={12}>
                                <div className='search-input-container mx-2 mt-1'>
                                    <CFormInput
                                        value={states.searchDsPhonebookContactsText}
                                        onChange={(e) => {
                                            let value = e.target.value
                                            if (value !== '') {
                                                if (checkForNumericEnFaString(value)) {
                                                    value = persianToEnglishChar(value)
                                                    setStates({ searchDsPhonebookContactsText: value })
                                                } else {
                                                    setStates({ searchDsPhonebookContactsText: value })

                                                }
                                            } else {
                                                setStates({ searchDsPhonebookContactsText: '' })

                                            }
                                            handleSearchOnPhonebookContacts(value)

                                        }}
                                        type="text"
                                        className="form-control"
                                        placeholder='search'
                                    />
                                    {states.searchText && <span className='remove-selected-spn'
                                        onClick={(e) => {
                                            setStates({ searchText: '' })

                                        }} >
                                        <CloseSVG fill='red' />
                                    </span>}
                                    <span>
                                        <SearchSVG width={20} height={20} fill='#333' />
                                    </span>
                                </div>

                            </CCol>



                        </CRow>
                    </div>

                </div>
                <div className='scrollable-context' >
                    <GSPTable
                        columns={states.columns}
                        hasSorting={false}
                        dataList={{ data: states.phonebookContacts ? states.phonebookContacts : [] }}
                        // apiCall={handleSearchOnPhonebookContacts}
                        hasFiltering={false}
                        loading={getDataPending}
                        enableScrolling={false}
                        hasPaging={false}
                        pageSize={10}
                        isDynamicColumns={false}
                        customProps={{
                            selectedList: states.selectionList,
                            setInnerSelectedList: setStates,
                            phonebookList: phonebooks?.data,
                            contactCategories: contactCategories?.data,
                            updateContact: handleUpdateContact,
                            updateContactPending: updateContactPending,
                            handleBlock: handleBlockContacts
                        }}
                        customCardView={customCardView}
                        setDataListFromItem={(list) => { setStates({ contacts: { ...states.contacts, data: list } }) }}
                    />
                    {states.phonebookContacts.length === 0 && <p className='d-flex justify-content-center'>
                        هیچ مخاطبی وجود ندارد
                    </p>}
                </div>


            </>}

        </div>
    )
}

export default DSApplicationContact